// SAL6010_R01 API 모듈
// - 견적서 목록/상세 조회, 생성/수정/삭제, 엑셀/인쇄 API를 제공합니다.
// - 화면에서는 본 모듈의 함수들을 통해 서버 통신을 수행합니다.
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";

import { SAL6010_R01DetailDto, SAL6010_R01Dto, SAL6010_R01HeaderDto } from "./Dto_SAL6010_R01";
import { SAL6010_R01Filter } from "./Store_SAL6010_R01";

// 엔드포인트 기본 경로
const baseUrl = `${config.apiUrl}/SAL6010_R01`;

// 목록 조회용 공통 파라미터 빌더
const getParams = (filter: Partial<SAL6010_R01Filter>, listLength?: number) => {
	return {
		"salEstimateHeaderDto.compCd": filter.compCd || undefined,
		"salEstimateHeaderDto.customCd": filter.custInput || undefined,
		"salEstimateHeaderDto.salesEstimateNo": filter.salesEstimateNo || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		listLength: listLength || 0,
	};
};

// 견적서 목록 조회
export const getSAL6010_R01List = async (option: string, params: Partial<SAL6010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<SAL6010_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
};

// 전체 건수 조회
export const getSAL6010_R01AllCount = async (params: Partial<SAL6010_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: getParams(params, 0),
	});
};

// 견적서 단건 조회
export const getSAL6010_R01One = async (salesEstimateNo: string) => {
	const url = `${baseUrl}/one/${salesEstimateNo}`;
	return await getData<ResponseDto<SAL6010_R01HeaderDto>>(url);
};

// 견적서 상세(라인) 목록 조회
export const getSAL6010_R01DetailList = async (salesEstimateNo: string) => {
	const url = `${baseUrl}/detail/${salesEstimateNo}`;
	return await getData<ResponseDto<SAL6010_R01DetailDto[]>>(url);
};

// 견적서 생성
export const postSAL6010_R01 = async (data: SAL6010_R01Dto) => {
	const url = `${baseUrl}`;
	return await postData<SAL6010_R01Dto, ResponseDto<SAL6010_R01Dto[]>>(url, data);
};

// 견적서 수정
export const patchSAL6010_R01 = async (data: SAL6010_R01Dto) => {
	const url = `${baseUrl}`;
	return await patchData<SAL6010_R01Dto, ResponseDto<SAL6010_R01Dto[]>>(url, data);
};

// 견적서 삭제 (헤더 단건)
export const deleteSAL6010_R01 = async (salesEstimateNo: string) => {
	const url = `${baseUrl}`;
	return await deleteData<ResponseDto<any>>(url, {
		params: { salesEstimateNo },
	});
};

// 견적서 양식 엑셀 다운로드
export const downloadExcel_SAL6010_R01 = async (salesEstimateNo: string) => {
	const url = `${baseUrl}/excel`;
	return await getData<ResponseDto<string>>(url, {
		params: { salesEstimateNo },
	});
};

/**
 * 견적서 PDF Blob 반환
 * - QZ Tray 연결 시 → printPdfFromBlob()으로 프린터 출력
 * - QZ Tray 미연결 시 → URL.createObjectURL → 새 탭 열기
 */
export const getPdfBlob_SAL6010_R01 = async (salesEstimateNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { salesEstimateNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
